// Note: We are now hiding the CustomerSegmentation Widget in the Dashboard
// https://trello.com/c/GsHgVSLR/394-deactivate-customer-segmentation-for-startups
import { intializeStoreActionTypes } from "shared/redux-store/initializeStore";
import { fulfilled } from "shared/redux-store";
import _keyBy from "lodash/keyBy";
import _pick from "lodash/pick";
import _merge from "lodash/merge";
import _mapValues from "lodash/mapValues";
import { startupsDashboardActionTypes } from "./StartupsDashboardActions";

// eslint-disable-next-line func-names
export default function (store = {}, action) {
  switch (action.type) {
    case intializeStoreActionTypes.INITIALIZE_STORE: {
      return {
        ...store,
        StartupsDashboard: {
          activeTabKey: 0,
        },
        productLinesAnalytics: {},
        productLines: {},
      };
    }

    case startupsDashboardActionTypes.FETCH_PRODUCT_LINES: {
      const productLines = _keyBy(action.payload, "name");
      const productLinesAnalytics = _mapValues(productLines, productLine =>
        _pick(productLine, "name"),
      );
      return {
        ...store,
        productLines: { ...store.productLines, ...productLines },
        productLinesAnalytics: _merge(
          store.productLinesAnalytics,
          productLinesAnalytics,
        ),
      };
    }

    case startupsDashboardActionTypes.SELECT_TAB: {
      return {
        ...store,
        StartupsDashboard: {
          ...store.StartupsDashboard,
          activeTabKey: action.payload,
        },
      };
    }

    case fulfilled(startupsDashboardActionTypes.FETCH_PRODUCT_ANALYTICS): {
      const productLineBasicAnalyticsData = action.payload.data;
      const productLineAnalyticsId = action.payload.config.params.productLine;
      return {
        ...store,
        productLinesAnalytics: _merge(store.productLinesAnalytics, {
          [productLineAnalyticsId]: productLineBasicAnalyticsData,
        }),
      };
    }

    case fulfilled(
      startupsDashboardActionTypes.FETCH_PRODUCT_CUSTOMER_SEGMENTATION,
    ): {
      const productCustomerSegmentationData = action.payload.data;
      const productLineAnalyticsId = action.payload.config.params.productLine;
      return {
        ...store,
        productLinesAnalytics: _merge(store.productLinesAnalytics, {
          [productLineAnalyticsId]: {
            customerSegmentation: productCustomerSegmentationData,
          },
        }),
      };
    }

    default: {
      return store;
    }
  }
}
